import { gql } from '@apollo/client';

export const ALL_FUNDER_USERS_FOR_SELECT_INPUT = gql`
  query AllFunderUsers($input: UserFilterInput!) {
    users: allFunderUsers(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
`;
